var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-toast',{attrs:{"visible":_vm.visible,"animation":"ascend"},on:{"update:visible":function($event){_vm.visible=$event}}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n    "),_c('button',{on:{"click":_vm.clear}},[_vm._v("ok")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7716fd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Notification.vue
// module id = null
// module chunks = 